import { APP_VERSION } from './constants';

export interface DiagnosticState {
  connectionState: string;
  iceState: string;
  signalingState: string;
  capabilityTier?: string;
  directoryPicker?: boolean;
  filePicker?: boolean;
  peerCanReceive?: boolean;
  candidateType?: string;
  protocol?: string;
  roundTripTimeMs?: number;
  lastErrorCode?: string;
}

export function buildDiagnostics(state: DiagnosticState): string {
  return JSON.stringify({
    appVersion: APP_VERSION,
    generatedAt: new Date().toISOString(),
    browser: navigator.userAgent,
    secureContext: window.isSecureContext,
    online: navigator.onLine,
    ...state,
  }, null, 2);
}

export async function copyDiagnostics(state: DiagnosticState): Promise<void> {
  await navigator.clipboard.writeText(buildDiagnostics(state));
}
